import { el } from './dom.js';
import { createPillButton } from './pillButton.js';

export type PageEmptyStateAction = {
  label: string;
  href?: string;
  variant?: 'cta' | 'soft';
  large?: boolean;
  small?: boolean;
  onClick?: () => void;
};

export type PageEmptyStateOptions = {
  title: string;
  description?: string;
  /** Action principale (pill CTA par défaut). */
  primaryAction?: PageEmptyStateAction;
  /** Action secondaire (pill soft). */
  secondaryAction?: PageEmptyStateAction;
};

function appendAction(container: HTMLElement, action: PageEmptyStateAction): void {
  const btn = createPillButton(action.label, {
    href: action.href,
    variant: action.variant ?? (action.href ? 'cta' : 'soft'),
    large: action.large,
    small: action.small,
    onClick: action.onClick,
  });
  container.appendChild(btn);
}

/** Bloc vide centré + boutons pill (même style que le tableau de bord). */
export function createPageEmptyState(options: PageEmptyStateOptions): HTMLElement {
  const block = el('div', { class: 'page-empty-state' });
  block.appendChild(el('p', { class: 'page-empty-state__title', text: options.title }));
  if (options.description) {
    block.appendChild(el('p', { class: 'page-empty-state__desc', text: options.description }));
  }
  if (options.primaryAction || options.secondaryAction) {
    const actions = el('div', { class: 'page-empty-state__actions' });
    if (options.primaryAction) appendAction(actions, { variant: 'cta', ...options.primaryAction });
    if (options.secondaryAction) {
      appendAction(actions, { variant: 'soft', small: true, ...options.secondaryAction });
    }
    block.appendChild(actions);
  }
  return block;
}
